import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Loading, Modal, UnorderedList, ListItem } from '@carbon/react';

import { showToast } from 'services/toasts';
import { useDeleteStreamMutation } from 'services/stream';

// Bulk-delete confirmation for streams. Mirrors the single-stream
// modal's UX (danger style, "Löschen" / "Abbrechen") and surfaces an
// extra warning when any of the selected streams is still attached to
// a device — without it the devices would silently lose their player
// content the moment the delete goes through.
const DeleteMultipleStreamsModal = ({ streams = [], hideModal, cb = () => {} }) => {
  const dispatch = useDispatch();
  const [deleteStream] = useDeleteStreamMutation();
  const [isLoading, setIsLoading] = useState(false);

  const linked = streams.filter((s) => (s.devices_id || s.devices || []).length > 0);

  return (
    <Modal
      open={true}
      danger={true}
      size="sm"
      primaryButtonText="Löschen"
      secondaryButtonText="Abbrechen"
      modalHeading="Sollen die ausgewählten Streams wirklich gelöscht werden?"
      onRequestClose={hideModal}
      onRequestSubmit={async () => {
        setIsLoading(true);
        let failures = 0;
        for (const stream of streams) {
          try {
            await deleteStream(stream.model.ID).unwrap();
          } catch {
            failures += 1;
          }
        }
        setIsLoading(false);

        if (failures > 0) {
          dispatch(showToast({
            kind: 'error',
            title: 'Fehler',
            caption: `${failures} Stream(s) konnten nicht gelöscht werden`,
          }));
        }
        if (failures < streams.length) {
          dispatch(showToast({
            kind: 'success',
            title: 'Streams gelöscht',
            caption: `${streams.length - failures} Stream(s) wurden gelöscht`,
          }));
        }
        cb();
        hideModal();
      }}>
      <p style={{ marginBottom: '0.75rem' }}>
        {streams.length} Stream(s) werden gelöscht.
      </p>
      {linked.length > 0 && (
        <>
          <p style={{ marginBottom: '0.5rem' }}>
            Folgende Streams sind noch mit micast-Systemen verknüpft. Beim
            Löschen werden auf den Geräten keine Elemente mehr angezeigt:
          </p>
          <UnorderedList>
            {linked.map((s) => (
              <ListItem key={s.model.ID}>{s.name || `Stream #${s.model.ID}`}</ListItem>
            ))}
          </UnorderedList>
        </>
      )}
      <Loading active={isLoading} withOverlay={true} />
    </Modal>
  );
};

export default DeleteMultipleStreamsModal;
